import axios from 'axios';
import {backendHost} from '../../config';

export const putChangeStatusMedia = (params) => {
    return axios.put(`${backendHost}/api/partners/admin/media/change-active`, params);
};